import FeatureFlags from 'types/FeatureFlags';

export default function useFeatureFlags(): FeatureFlags {
  return global.__AT_STORE__.featureFlags;
}
